import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ColorFamily } from '@ppg/core/models';
import { BackgroundDirective, FontColorBasedOnBackgroundDirective } from '@ppg/shared/components';

@Component({
  selector: 'ppg-color-family-switcher-item',
  standalone: true,
  imports: [BackgroundDirective, FontColorBasedOnBackgroundDirective],
  templateUrl: './color-family-switcher-item.component.html',
  styleUrl: './color-family-switcher-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorFamilySwitcherItemComponent {
  readonly colorFamily = input.required<ColorFamily>();
  readonly isSelected = input.required<boolean>();
  readonly colorFamilyClick = output<ColorFamily>();

  showSelector = false;

  onColorFamilyClick() {
    this.colorFamilyClick.emit(this.colorFamily());
  }
}
